import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Button, Input, Icon } from 'components/ui';
import { composeValidators, required, minLength } from 'services/forms';
import './style.css';
import { GoogleLogin } from '@react-oauth/google';

const responseGoogle = response => {
  console.log(response);
};

function AuthForm() {
  return (
    <GoogleLogin
      hosted_domain="turing.com"
      onError={responseGoogle}
      onSuccess={responseGoogle}
    />
  );
}

AuthForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AuthForm;
